import React, {useEffect} from 'react';
import useUserStore from 'common/stores/user';

/**
 * @return {JSX.Element}
 * @constructor
 */
const Login: React.FC = () => {
	const {login} = useUserStore();

	useEffect(() => {
		login();
	}, [login]);

	return <></>;
}

export default Login;
